import { useEffect, useMemo, useRef } from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { useSnackbar } from "notistack";

import type { RootState } from "../../state/store";
import { createAppRoutes } from "../../utilities/appRoutes";
import { accessChange, describeAccessChange } from "../../utilities/helpers/accessChange";
import { routeChainAt } from "../../utilities/helpers/routeAccess";

export function AccessChangeNotice() {
  const { enqueueSnackbar } = useSnackbar();
  const user = useSelector((state: RootState) => state.authReducer.user);
  const { pathname } = useLocation();
  const telemetryEnabled = useSelector((state: RootState) => state.authReducer.roleConfig?.telemetryEnabled);
  const routes = useMemo(() => createAppRoutes({ telemetryEnabled }), [telemetryEnabled]);
  const previousUser = useRef(user);

  useEffect(() => {
    const change = accessChange(previousUser.current, user, routeChainAt(routes, pathname));
    previousUser.current = user;

    if (change) enqueueSnackbar(describeAccessChange(change), { variant: "info", autoHideDuration: 8000 });
  }, [user, pathname, routes, enqueueSnackbar]);

  return null;
}
